



























import { Component, Vue, Model, Prop, Ref } from "vue-property-decorator";
import { VData } from "vuetify/lib";
import NumberButton from "./number-button.vue";

@Component({
  components: {
    "button-number": () => Promise.resolve(NumberButton),
  },
})
export default class NumberSelector extends Vue {
  @Model("change")
  public vmodel!: number[];
  @Prop({ required: true, type: Number })
  public qtde!: number;
  @Prop({ type: Boolean })
  public onlyModelValues!: boolean;
  @Prop({ type: Boolean })
  public readonly!: boolean;
  @Prop({ type: Number })
  public size!: number;

  numbersKey = 0;
  selectedNumbers: any = [];

  get numbers() {
    var numbers: number[] = [];
    for (var i = 1; i <= this.qtde; i++) {
      var v = i == 100 ? 0 : i;
      if (this.onlyModelValues) {
        if (this.vmodel.includes(i)) {
          numbers.push(v);
          this.selectedNumbers.push(v);
        }
      } else {
        numbers.push(v);
        this.selectedNumbers = this.vmodel;
      }
      //this.numbers.push({ number: i, selected: false });
    }
    return numbers;
  }

  formatedNumber(number: number) {
    return number < 10 ? "0" + number : number;
  }

  color(number: any) {
    if (this.selectedNumbers)
      return this.selectedNumbers.includes(number)
        ? "primary"
        : "lotojr_numberDisable";
    return "lotojr_numberDisable";
  }

  onChange(value: any) {
    if (!this.readonly) {
      if (!this.onlyModelValues) {
        this.numbersKey += 1;
        if (this.selectedNumbers.includes(value)) {
          this.selectedNumbers.splice(this.selectedNumbers.indexOf(value), 1);
        } else {
          this.selectedNumbers.push(value);
        }
        this.$emit("change", this.selectedNumbers);
      }
    }
  }

  beforeDestroy() {
    //this.numbers = [];
    // this.selectedNumbers = [];
  }

  onClose() {}
}
